import clsx from 'classnames'
import { useEffect, useMemo, useState } from 'react'
import { Route, Switch } from 'react-router'
import { BrowserRouter } from 'react-router-dom'

import { EventEmitterType, NavigationBar, ScaledViewport, eventEmitter, getNativeInfo } from '@docs/common'
import loadable from '@loadable/component'

import axios from 'axios'
import Routes from 'common/routes'
import { getQueryParam } from 'common/utils'

const Sandbox = loadable(() => import('./Sandbox'))
const History = loadable(() => import('./pages/babyCare/history'))
const RealRate = loadable(() => import('./pages/babyCare/HeartRate'))
const BloodOxygen = loadable(() => import('./pages/babyCare/bloodOxygen'))

const sall = (fn: () => void) => fn()

const BASE = 375

function App() {
  const [base, setBase] = useState(BASE)
  const [appName, setAppName] = useState<string>()
  const [serviceEnv, setServiceEnv] = useState(null)

  const themeClass = useMemo(() => {
    // 检查URL参数中是否有theme=dark
    const themeParam = getQueryParam('theme')
    let themeClass = ''
    
    if (!!appName) {
      console.log('appName', appName)
      themeClass = `theme-${appName}`.replace(/\s/g, '-').toLowerCase()
      // return `theme-${appName}`.replace(/\s/g, '-').toLowerCase()
    }
    
    // 如果URL参数中有theme=dark，返回dark-theme类名
    if (themeParam === 'dark') {
      themeClass = 'dark-theme'
      // return 'dark-theme'
    }
    return themeClass
  }, [appName])
    // 获取服务端的环境变量存储在 sessionStorage 中，以便客户端获取
    useEffect(() => {
      console.log('get envs')
      // 调用接口获取环境变量
      if (window.sessionStorage.getItem('ENVS')) {
        // start_ai_generated
        const envs = window.sessionStorage.getItem('ENVS')
        if (envs) {
          setServiceEnv(JSON.parse(envs))
        }
        // end_ai_generated
        return
      }
      axios.get('/config').then(res => {
        window.sessionStorage.setItem('ENVS', JSON.stringify(res.data))
        const envs = window.sessionStorage.getItem('ENVS')
        if (envs) {
          setServiceEnv(JSON.parse(envs))
        }
      })
    }, [])


  // useEffect(() => {
  //   sall(async () => {
  //     const app = getQueryParam('app')
      
  //     const info = await getNativeInfo()
  //     const { appName, userInterfaceStyle } = info
      
  //     setAppName(appName)
  //     if (app) {
  //       setAppName(app)
  //     } 
  //     console.log('getNativeInfo ===', info);
  //     document.body.classList.toggle('dark-theme', parseInt(userInterfaceStyle || '0') === 2)
  //     eventEmitter.emit(EventEmitterType.toggleTheme, parseInt(userInterfaceStyle || '0'))
  //   })
  // }, [])
  useEffect(() => {
    sall(async () => {
    console.log('useEffect=>>>');
      const app = getQueryParam('app')
      const info = await getNativeInfo()
      const { appName, userInterfaceStyle } = info
      const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)')?.matches
      setAppName(appName)
      if (app) {
        console.log('app', app);
        setAppName(app)
      }
      console.log('app_name', app, appName);
      let appTheme =parseInt(navigator.userAgent.match(/appTheme\/(\d+)/)?.[1]||"-1") 
      console.log('appTheme=>>>', appTheme)
      console.log('navigator=>>>', navigator.userAgent)
      if (appTheme===2||appTheme===1) {
        document.body.classList.toggle('dark-theme', appTheme === 2)
        eventEmitter.emit(EventEmitterType.toggleTheme, appTheme)
      } else if (appTheme===0) {
        console.log('isDarkMode', isDarkMode,window.matchMedia('(prefers-color-scheme: dark)'));
        document.body.classList.toggle('dark-theme', isDarkMode)
        eventEmitter.emit(EventEmitterType.toggleTheme, isDarkMode?2:1)
        // document.body.classList.toggle('dark-theme', true)
        // eventEmitter.emit(EventEmitterType.toggleTheme, 2)
      } else if (appTheme===-1) {
        console.log('userInterfaceStyle', userInterfaceStyle);
        
        document.body.classList.toggle('dark-theme', parseInt(userInterfaceStyle || '0') === 2||isDarkMode)
        eventEmitter.emit(EventEmitterType.toggleTheme, parseInt(userInterfaceStyle || '0')||(isDarkMode?2:1))
      } else {
        // 初始化时根据系统主题设置
        document.body.classList.toggle('dark-theme', isDarkMode)
        eventEmitter.emit(EventEmitterType.toggleTheme, isDarkMode ? 2 : 1)
      }
    })
  }, [])

  useEffect(() => {
    const setbase = () => {
      const isSmartScreen = /apptheme\/\d+/.test(navigator.userAgent)
      const isLandscape = window.outerWidth > window.outerHeight
      if ((isSmartScreen && isLandscape) || window.orientation === 90 || window.orientation === -90) {
        setBase(window.outerWidth)
      } else {
        setBase(BASE)
      }
    }
    window.addEventListener('orientationchange', setbase)
    setbase()
  }, [])
  const renderConsole = () => {
    import('vconsole').then(m => {
      const VConsole = m.default
      new VConsole({
        onReady: () => {
          const v = document.querySelector('#__vconsole')
          if (v) {
            document.body.appendChild(v)
          }
        },
      })
    })
  }
  useEffect(() => {
    if (!serviceEnv) {
      return
    }
    if (['qa', 'smoke', 'stress', 'sqa'].includes(serviceEnv['REACT_APP_DEPLOY_ENV']) || window.location.search?.indexOf('_CONSOLE=1') > -1) {
      renderConsole()
    }
  }, [serviceEnv])

  return serviceEnv ? (
    <div className={clsx('App', themeClass)}>
      <BrowserRouter>
        <Switch>
          <Route path="/sandbox/:url" component={Sandbox} />
          <Route path="/babyCare/history" component={History} />
          <Route path="/babyCare/realHeartRate" component={RealRate} />
          <Route path="/babyCare/realBloodOxygen" component={BloodOxygen} />
          <Route render={(props) => {
            return (
              <>
                <ScaledViewport base={base} />
                <NavigationBar />
                <Routes />
              </>
            )
          }}>
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  ):null
}

export default App
